var _react_refresh_temp_1;
var _react_refresh_temp_2;
_react_refresh_temp_2 = $RefreshSig$();
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useMemo } from 'react';
import { Box, FieldValidation, NumberInput, } from '#design-system';
import { useField, useFieldDependency } from '#form-builder';
import { C } from '#integrations';
import styles from './NumberInputField.module.css';
const defaultValidationRules = [];
export const NumberInputField = ({ 'aria-label': ariaLabel, 'aria-labelledby': ariaLabelledBy, autoFocus, className, clientErrorMessage, copyProps, 'data-testid': testId, description, disabled, id, initialValue, isWheelEventDisabled, label, labelTooltip, max, min, onKeyDown, placeholder, readOnly, required, rules = defaultValidationRules, tooltipPosition, ...props }) => {
    _react_refresh_temp_2();
    const builtInitialValue = useMemo(() => {
        if (typeof initialValue === 'function') {
            return initialValue({}) || '';
        }
        else {
            return initialValue || '';
        }
    }, [initialValue]);
    const { 
    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment -- dependencyValue is any on purpose
    dependencyValue, errors, fieldRef, isFocused, isTouched, onBlurHandler, onChangeHandler, onFocusHandler, value, } = useField({
        autoFocus,
        ...props,
        disabled,
        initialValue: builtInitialValue,
    });
    const dependantData = useFieldDependency({
        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment -- dependencyValue is any on purpose
        dependencyValue,
        disabled,
        label,
        required,
    });
    const hasErrors = Boolean(errors.length) && isTouched;
    const fieldValidationId = `field-validation-${id}`;
    return (_jsxs(Box, { className: C(styles.Container, className), gap: "xs", isFullWidth: true, orientation: "vertical", children: [_jsx(NumberInput, { "aria-describedby": fieldValidationId, ...(hasErrors && { 'aria-errormessage': fieldValidationId }), ...(hasErrors && { 'aria-invalid': true }), "aria-label": ariaLabel, "aria-labelledby": ariaLabelledBy, autoFocus: autoFocus, copyProps: copyProps, "data-testid": testId, description: description, disabled: dependantData.disabled, hasErrors: hasErrors, id: id, isWheelEventDisabled: isWheelEventDisabled, label: dependantData.label, labelTooltip: labelTooltip, max: max, min: min, onBlur: onBlurHandler, onChange: (event) => {
                    onChangeHandler(event.target.value);
                }, onFocus: onFocusHandler, onKeyDown: onKeyDown, placeholder: placeholder, readOnly: readOnly, ref: fieldRef, required: dependantData.required, tooltipPosition: tooltipPosition, value: value }), _jsx(FieldValidation, { clientErrorMessage: clientErrorMessage, "data-testid": testId, errors: errors, id: fieldValidationId, isActive: isTouched, isFocused: isFocused, rules: rules })] }));
};
_react_refresh_temp_1 = NumberInputField;
$RefreshReg$(_react_refresh_temp_1, "NumberInputField");
_react_refresh_temp_2(NumberInputField, "7LnEM1IR9rsqY4ujvpRYmMDdRBE=", false, () => [useField, useFieldDependency]);
